import React from 'react';
import { useState, useMemo } from 'react';
import { Input, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { NewHC200Icon, UnassignedHS200DeviceIcon } from '../../Common/Icons';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const showDevice = (hub) => !!hub.deviceuuid;

const AddAccount = ({
  userHubsData = [],
  selectedAccounts = [],
  onAccountSelect,
  onAccountDeselect,
}) => {
  const trans = useSelector(translator);
  const displayAccountList = useMemo(() => {
    return userHubsData;
  }, [userHubsData]);

  const [searchText, setSearchText] = useState('');

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText('');
  };

  // Filter accounts based on search
  const filteredAccounts = useMemo(() => {
    if (!searchText || !searchText.trim()) {
      return displayAccountList;
    }

    const searchTerm = searchText.toLowerCase();
    return displayAccountList.filter((account) => {
      const fullName = `${account.firstname || ''} ${account.lastname || ''}`.toLowerCase();
      const email = (account.email || '').toLowerCase();
      const username = (account.username || '').toLowerCase();

      return (
        fullName.includes(searchTerm) || email.includes(searchTerm) || username.includes(searchTerm)
      );
    });
  }, [displayAccountList, searchText]);

  // Handle account selection toggle
  const handleAccountClick = (account) => {
    const isSelected = isAccountSelected(account);
    if (isSelected) {
      onAccountDeselect && onAccountDeselect(account);
    } else {
      onAccountSelect && onAccountSelect(account);
    }
  };

  // Check if account is selected
  const isAccountSelected = (account) => {
    return selectedAccounts.some((selected) => selected.useruuid === account.useruuid);
  };

  return (
    <div className="add-member-container">
      {/* Search Section */}
      <div className="search-section">
        <Input
          className="search-input"
          value={searchText}
          onChange={handleSearchChange}
          placeholder={trans('SEARCH')}
          allowClear
        />
      </div>

      {/* Members List */}
      <div className="members-list-container">
        {filteredAccounts.length > 0 ? (
          filteredAccounts.map((account, index) => (
            <div
              key={`account-${account.useruuid}-${index}`}
              className={`member-item ${isAccountSelected(account) ? 'selected' : ''}`}
              onClick={() => handleAccountClick(account)}
            >
              <Avatar
                size={60}
                src={account.profilePic64}
                icon={<UserOutlined />}
                className="group-member-avatar"
              />
              <div className="member-name">
                {`${account.firstname || ''} ${account.lastname || ''}`.trim() ||
                  account.username ||
                  trans('UNKNOWNUSER')}
              </div>
              <div className="device-icon-container">
                {showDevice(account) ? (
                  <NewHC200Icon
                    style={{ backgroundColor: '#ccdce4' }}
                    status={
                      account?.deviceconnectstatus?.toLowerCase() === 'connected'
                        ? 'connected'
                        : 'disconnected'
                    }
                  />
                ) : (
                  <UnassignedHS200DeviceIcon />
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-members-container">
            <div className="no-members-message">
              {searchText ? trans('NOMEMBERSFOUNDMATCHINGYOURSEARCH') : trans('NOMEMBERSAVAILABLE')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddAccount;
